import { Injectable } from "@angular/core";
import { CookieBarService } from "ras-cookie-bar";
import { RasGtmService } from "ras-gtm";
import { forkJoin, Observable } from "rxjs";
import { take } from "rxjs/operators";
import { Gender } from '../../enums';
import { ContractType, SessionInfoModel } from "../../models";
import { CommonService } from '../ui/common.service';

@Injectable({
  providedIn: 'root'
})
export class GtmDatalayerUiService {

  constructor(private rasGtmService: RasGtmService, private cookieBarService: CookieBarService, private commonService: CommonService) { }
  public cjerrormessage = "";
  public initGtmDatalayer(sessionInfo$: Observable<SessionInfoModel>): Observable<boolean> {

    return new Observable<boolean>((subscriber) => {

      forkJoin(
        this.cookieBarService.getCookieConsent().pipe(take(1)),
        sessionInfo$.pipe(take(1))
      ).subscribe(([consent, sessionInfo]) => {

        
        
        setTimeout(() => {
          this.addSessionTrackingId(sessionInfo.sessionTrackingId).pipe(take(1)).subscribe({
            next: () => {

              this.addPageType().pipe(take(1)).subscribe({
                next: () => {
                  this.addVirtualPage("q1", 1, "Titular del seguro - codigo postal - Teléfono - Email", "", "").pipe(take(1)).subscribe({
                    next: () => {
                      this.rasGtmService.addGtmToDom().pipe(take(1)).subscribe({
                        next: () => {
                          subscriber.next(true);
                          subscriber.complete();
                        }
                      })
                    }
                  });
                }
              });
            }
          });
        }, 2000);
      });

    });
  }

  private addSessionTrackingId(sessionTrackingId): Observable<boolean> {
    return this.rasGtmService.pushOnDataLayer({ sessionid: sessionTrackingId });
  }
  

  private addPageType(): Observable<boolean> {
    return this.rasGtmService.pushOnDataLayer(
      {
        productCategory: "insurance",
        productcg: "burial",
        testversion: "",
        typepage: "cj burial"
      });
  }

  public addVirtualPage(qKey: string, sectionIndex: number, questionText: string, abTestName: string, abTestValue: string): Observable<boolean> {

    return this.rasGtmService.pushOnDataLayer({
      event: "virtualpage",
      category: "insurance",
      product: "burial",
      virtualpage: "customerjourney",
      question: qKey ? qKey.toLowerCase() : null,
      questiontext: questionText,
      section: "section" + sectionIndex,
      testversion: abTestName == undefined ? "" : abTestName + "_" + abTestValue == undefined ? "" : abTestValue
    });

  }

  public addVirtualPageValidationError(qKey: string, sectionIndex: number, errorSummary: string): Observable<boolean> {

    return this.rasGtmService.pushOnDataLayer({
      event: "virtualpage",
      category: "insurance",
      product: "burial",
      virtualpage: "customerjourneyerror",
      question: qKey ? qKey.toLowerCase() : null,
      cjerrormessage: errorSummary,
      section: "section" + sectionIndex,
    });

  }
  public addPreviousQuoteOnloadScreen(qKey: string, virtualpage: string): Observable<boolean> {

    return this.rasGtmService.pushOnDataLayer({
      event: 'virtualpage',
      virtualpage: virtualpage,
      category: 'insurance',
      product: 'burial',
      lastquotepopupscreen: qKey
    });

  }
  public customerjourneyerror(): Observable<boolean> {
    console.log(this.cjerrormessage);
    return this.rasGtmService.pushOnDataLayer({
      event: "virtualpage",
      virtualpage: "customerjourneyerror",
      category: "insurance",
      product: "burial",
      section: "section1",
      question: "q1",
      cjerrormessage: this.cjerrormessage.substring(3),

    });

  }
  setCjError(error: string, reset: boolean = false) {
    if (reset) {
      this.cjerrormessage=""
    }
    else {
      this.cjerrormessage = this.cjerrormessage + " - " + error;
    }
  }
  public saveAnswerDataLayerEvent(contractType: ContractType): Observable<boolean> {
    return this.rasGtmService.pushOnDataLayer({
      event: "cjanswer",
      cjcategory: 'insurance',
      cjproduct: 'burial',
      questionanswer: "q1",
      answer: this.createAnswerData(contractType)
    });

  }
  private createAnswerData(contractType: ContractType): string {
    let gender = contractType.policyHolder[0].gender == Gender.Female ? "Female" : "Male";
    var ans = contractType.policyHolder.length + " - " + gender + " - " + this.commonService.isValidDateRange(new Date(contractType.policyHolder[0].birthDate)) + " - " + contractType.province;
    return ans;
  }
  public addPreviousQuoteAnsware(qKey: string, answare: string): Observable<boolean> {

    return this.rasGtmService.pushOnDataLayer({
      event: 'lastquotepopupanswer',
      lastquotepopupanswer: answare,
      lastquotepopupcategory: 'insurance',
      lastquotepopupproduct: 'burial',
      lastquotepopupscreen: qKey
    });

  }

  public addAnswer(qKey: string, answerStr: string): Observable<boolean> {

    return this.rasGtmService.pushOnDataLayer({
      event: "cjanswer",
      cjcategory: "insurance",
      cjproduct: "burial",
      questionanswer: qKey ? qKey.toLowerCase() : null,
      answer: answerStr
    });

  }

  public addAyudaFormEvent(channelValue: string): Observable<boolean> {
    return this.rasGtmService.pushOnDataLayer(
      {
        event: 'form',
        actionform: 'submit',
        form: 'ayuda',
        ayuda: channelValue,
        productform: 'burial'
      });
  }

  public upaLoginEvent(loginId: string): Observable<boolean> {
    return this.rasGtmService.pushOnDataLayer(
      {
        event: 'login',
        loginID: loginId
      });
  }
}
